<template>
  <div class="oauth-buttons my-2">
    <div v-if="highlighted" class="small text-muted text-center mb-2">
      This account uses {{ highlighted.name }} sign-in.
    </div>
    <b-btn
      v-for="p in providers"
      :id="`${idPrefix}-oauth-${p.id}`"
      :key="p.id"
      :variant="highlight === p.id ? 'primary' : 'link'"
      block
      @click="handleClick(p.id)"
    >
      <i :class="`mr-2 fa fa-${p.icon || p.id}`" />Continue with {{ p.name }}
    </b-btn>
  </div>
</template>

<script>
import API from "@/api";

export default {
  props: {
    // provider to highlight, e.g. after a PLEASE_SIGN_IN_WITH_GOOGLE error
    highlight: {
      type: String,
      default: null
    },
    idPrefix: {
      type: String,
      default: "login"
    }
  },

  data: () => ({
    providers: [
      { id: "google", name: "Google" },
      { id: "microsoft", name: "Microsoft", icon: "windows" },
      { id: "apple", name: "Apple" }
    ]
  }),

  computed: {
    highlighted() {
      return this.providers.find(p => p.id === this.highlight);
    }
  },

  methods: {
    async handleClick(provider) {
      const { success, results } = await API.loginOAuth(
        provider,
        location.href
      );
      if (!success) return;

      window.open(results, "_self");
    }
  }
};
</script>
